import { Component } from '@angular/core';
import { SessionDetailPage } from '../../pages/session-detail/session-detail';
import { ModalController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import moment from 'moment';

@Component({
  selector: 'user-details-user',
  templateUrl: 'user-details-user.html'
})
export class UserDetailsUserComponent {
  currentUser: any;
  dataCoach: any;
  lastSession: any;
  nextSession: any;

  constructor(public modalCtrl: ModalController, public af: AngularFirestore, public afAuth: AngularFireAuth) {
    this.afAuth.auth.onAuthStateChanged(user => {
      if (user && user.uid) {
        this.af.doc("Users/" + user.uid).snapshotChanges().subscribe(snapshotChanges => {
          if (snapshotChanges && snapshotChanges.payload && snapshotChanges.payload.exists) {
            this.currentUser = snapshotChanges.payload.data();
          }
        });
        this.af.collection("Sessions").ref.where("idAlumno", "==", user.uid).where("sessionDate", "<=", new Date()).orderBy("sessionDate", "desc").limit(1).get().then(data => {
          data.forEach(element => {
            this.lastSession = element.data();
            this.lastSession.id = element.id;
          });
          if (this.lastSession && this.lastSession.sessionDate) {
            this.lastSession.sessionDate2 = this.stringDate(this.lastSession.sessionDate);
          }
        });
        this.af.collection("Sessions").ref.where("idAlumno", "==", user.uid).where("sessionDate", ">=", new Date()).orderBy("sessionDate", "asc").limit(1).get().then(data => {
          data.forEach(element => {
            this.nextSession = element.data();
            this.nextSession.id = element.id;
          });
          if (this.nextSession && this.nextSession.sessionDate) {
            this.nextSession.sessionDate2 = this.stringDate(this.nextSession.sessionDate);
          }
        });
      }
    });
  }

  dateFormatter(date: any) {
    return moment(date).format('L');
  }

  viewItem(item: any) {
    let Modal = this.modalCtrl.create(SessionDetailPage, { "item": item, taskList: true });
    Modal.present();

  }

  stringDate(date: any): string {
    moment.locale("es");
    return moment(date).format("lll");
  }

}


// WEBPACK FOOTER //
// ./src/components/user-details-user/user-details-user.ts